import {
  useExecutiveReportFields,
  buildPresentation,
  BuildReportOptions,
  clientDefaultValues,
} from '@features/executive-report/subdomains/rsl';
import { presentationToFile } from '@features/powerpoint';
import { Campaign, GetCampaignParams } from '@features/campaigns';
import { useCurrentUser } from '@features/users';
import { stringify } from 'qs';
import { useNavigate } from 'react-router-dom';
import { ExecutiveReportDownloadButton } from './ExecutiveReportDownload';
import { RslReportsParams } from '@features/campaigns/subdomains/rsl';
import { buildDefaultValues } from '@features/executive-report/subdomains/rsl/domain/v2/default-values';
import { useFeatures } from '@utils/hooks';

type RslExecutiveReportDownloadProps = {
  campaignId: Campaign['id'];
  reportParams: Omit<RslReportsParams, 'campaignId'>;
  campaignParams: GetCampaignParams;
};

export const RslExecutiveReportDownload = ({
  campaignId,
  campaignParams,
  reportParams,
}: RslExecutiveReportDownloadProps) => {
  const navigate = useNavigate();

  const { role: userRole } = useCurrentUser();
  const { data, loading } = useExecutiveReportFields({
    campaignParams: { ...campaignParams, id: campaignId },
    reportParams,
  });
  const { pptRedesign } = useFeatures();

  const onClickHandler = () => {
    if (userRole === 'user') {
      if (!data) throw new Error('Missing data for presentation');

      const options: BuildReportOptions = pptRedesign
        ? {
            ...data,
            designVersion: 'v2',
            brandLogo: null,
            customFields: buildDefaultValues(data.campaign.name),
          }
        : {
            ...data,
            designVersion: 'v1',
            brandLogo: null,
            customFields: clientDefaultValues(data.campaign.name),
          };

      const presentation = buildPresentation(options);

      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/rsl/${campaignId}/executive-report?${stringify({
          ...campaignParams,
          ...reportParams,
        })}`
      );
    }
  };

  return (
    <ExecutiveReportDownloadButton
      disabled={!data}
      loading={loading}
      onClickHandler={onClickHandler}
    />
  );
};
